import React from "react";
import Chart from "react-apexcharts";
import Big from "big.js";
import ICircleChart, { TCircleChart } from "./ICircleChart";
import { classNames } from "@features/utils/reactFunctions";
import { numberFormatter } from "@features/utils/functions";
import * as style from "./CircleChartStyle.module.scss"

const big = Big();

export default class CircleChart extends React.Component<
  ICircleChart,
  TCircleChart
> {
  constructor(props: ICircleChart) {
    super(props);

    this.state = {
      percentages: this.getPercentages(this.props.series),
      options: {
        labels: this.props.labels,
        dataLabels: { enabled: false },
        legend: { show: false },
        colors: this.props.colors,
        stroke: { width: 0 },
        tooltip: {
          y: {
            formatter: this.tooltipFormatter,
            title: {
              formatter: this.tooltipTitleFormatter,
            },
          },
        },
        states: {
          active: {
            filter: {
              type: "lighten",
              value: 0.15,
            },
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              size: "85%",
              labels: {
                total: {
                  show: false,
                },
              },
            },
          },
        },
        ...props.options,
      },
      series: this.props.series,
    };
  }

  tooltipFormatter = (value: number) =>
    value ? this.state.percentages[value] : "";

  tooltipTitleFormatter = (name: string) =>
    `${name}<span class="hide-title"></span>`;

  getPercentages = (data: number[]) => {
    const percentages: { [key: number]: string } = {};
    if (this.props.sum) {
      data.forEach(
        (el) =>
          (percentages[el] =
            big(el ?? 0)
              .div(this.props.sum ?? 0)
              .times(100)
              .toFixed(2) + "%")
      );
    }

    return percentages;
  };

  render() {
    return (
      <div className="circle-chart" id="circle-chart">
        <div
          className={classNames(
            style.chartHolder,
            this.props.series.length > 3 && style.chartHolderMargin
          )}
        >
          <p className={style.chartText}>
            {this.props.headline}{" "}
            <strong>${numberFormatter(this.props.sum)}</strong>
          </p>
          <Chart
            options={this.state.options}
            series={this.state.series}
            type="donut"
            width={this.props.width ?? "350"}
          />
        </div>
      </div>
    );
  }
}
